// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NGXI","col":"styles_col__1NkRf","actions":"styles_actions__2836N","conflict":"styles_conflict__1powm"};